import React from 'react';
import BenutzerList from '../../BenutzerList';

interface Props {
  authToken: string;
}

const BenutzerSection: React.FC<Props> = ({ authToken }) => (
  <BenutzerList authToken={authToken} />
);

export default BenutzerSection;
